// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OA-z","modalContent":"PA-z","header":"QA-z","close":"RA-z"};